import { render, staticRenderFns } from "./BonusPointExpiring.vue?vue&type=template&id=6a18c4f6&scoped=true&"
import script from "./BonusPointExpiring.vue?vue&type=script&lang=js&"
export * from "./BonusPointExpiring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18c4f6",
  null
  
)

export default component.exports